<template>
  <div id="app">

    <PreLoader v-if="!invisiblePreLoader" />

    <AlertMessage v-if="getShowAlert" />

    <transition name="fade">
      <Toast v-if='getShowToast' />
    </transition>

    <component :is="layout">
      <router-view :key="$route.path"></router-view>
    </component>

    <Wait v-if="getShowWait" />
    <UpScroll v-if="visibleUpScroll" />

  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue'
import AccountLayout from '@/layouts/AccountLayout.vue'
import Toast from '@/components/Toast.vue'
import AlertMessage from '@/components/AlertMessage.vue'
import Wait from '@/components/Wait.vue'
import UpScroll from '@/components/UpScroll.vue'
import PreLoader from '@/components/PreLoader.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    MainLayout,
    AccountLayout,
    Toast,
    AlertMessage,
    Wait,
    UpScroll,
    PreLoader
  },
  data() {
    return {
      visibleUpScroll: false,
      invisiblePreLoader: false,
    }
  },
  computed: {
    layout: function() {
      if (this.$route?.meta?.layout !== undefined) return this.$route.meta.layout
      return 'MainLayout'
    },
    ...mapGetters([ 'getShowToast', 'getShowWait', 'getUserData', 'getShowAlert' ])
  },
  created() {
    if (this.getCookie('s')) {  // проверяем наличие куки перед запросом аутентификации
      this.$store.dispatch('loginWithCookie')
      .catch(() => {
        // скрыть загрузчик
        this.invisiblePreLoader = true
      })
    } else {
      // скрыть загрузчик
      this.invisiblePreLoader = true
    }

    this.$store.subscribe((mutation/*, state*/) => {
      if (mutation.type === 'setUserData' /*&& mutation.payload === true*/) { 
        // если email не подтвержден редирект на окно подтверждения иначе в лк
        if (this.getUserData.emailConfirmRequired === true) {
          if (this.$route.name !== 'ConfirmEmail') {
            this.$store.commit('setLastSendConfirmEmailLetter', this.getUserData.email)
            this.$router.push({ name: 'ConfirmEmail' })

            // скрыть загрузчик
            this.invisiblePreLoader = true
          }
        } else if (this.$route.name !== 'Account' && this.$route.name !== 'Entrance') {
          this.$router.replace({ name: this.$store.getters.shouldBeRedirectedToEntrancePage ? 'Entrance' : 'Account' })

          // скрыть загрузчик
          this.invisiblePreLoader = true
        }
      }
      if (mutation.type === 'setShowFotoRedactor') {
        (mutation.payload) ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'visible'
      }
    });

    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    getCookie(name) {
      let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    handleScroll() {
      // видимость дива с кнопкой на верх
      this.visibleUpScroll = (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) ? true : false;
    },
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .8s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .changeDataButton {
    position: absolute;
    right: 14px;
    z-index: 30000;
  }

  .manualSection h4 a {
      color: inherit;
  }

  .manualSection .dataPreview {
      color: grey;
  }

  .manualSection .cmnt {
      font-size: smaller;
      margin-bottom: 0;
      margin-left: 20px;
  }

  .subsection {
      border-left-width: 10px;
      border-left-style: solid;
      border-color: transparent;
  }

  .list-group-item-success + .subsection {
      border-color: #c3e6cb;
  }

  .list-group-item-warning + .subsection {
      border-color: #ffeeba;
  }

  .list-group-item-danger + .subsection {
      border-color: #f5c6cb;
  }

  .manualSection.photo .subsection,
  .manualSection.request .subsection,
  .manualSection.payment .subsection
  {
      padding-left: 30px;
  }

  .subsection {
      padding-left: 10px;
  }
</style>
